import { render, staticRenderFns } from "./RxdFooterMobNavItem.vue?vue&type=template&id=77c4f5d6&scoped=true&"
import script from "./RxdFooterMobNavItem.vue?vue&type=script&lang=js&"
export * from "./RxdFooterMobNavItem.vue?vue&type=script&lang=js&"
import style0 from "./RxdFooterMobNavItem.vue?vue&type=style&index=0&id=77c4f5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4f5d6",
  null
  
)

export default component.exports